<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-login" class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center">
    <img v-if="!isMobile" :src="loginTopImage" style="position: absolute; left: 60px; top: 48px; width: 100%; max-width: 180px" alt="" class="xl" />
    <!--    그외 -->
    <div class="vx-col">
      <div v-if="isMobile" class="w-full text-center" style="margin-bottom: 32px; padding-top: 44px">
        <img :src="loginTopImage" alt="login" style="width: 70%; max-width: 300px; max-height: 160px" />
        <h6 class="mt-2">'일하는 모든 사람들의 안전과 건강을 지키는 기업'</h6>
      </div>
      <div v-else class="w-full text-center" style="margin-bottom: 36px">
        <img :src="loginTopImage" alt="login" style="width: 100%; max-width: 340px; max-height: 160px" />
        <h1 class="mt-1">'일하는 모든 사람들의 안전과 건강을 지키는 기업'</h1>
      </div>
      <vx-card class="overflow-hidden">
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center grid grid-cols-6 md:grid-cols-12" style="max-width: 1150px">
            <div class="vx-col hidden md:block col-span-6 login-image-container">
              <div v-if="!loginLeftImage" class="w-full h-full flex items-center justify-center">
                <img src="@/assets/images/pages/SHM_side_top.svg" alt="SHM_side_top" />
              </div>
              <img v-else :src="loginLeftImage" alt="login" class="login-left-image" />
            </div>
            <div class="vx-col h-full w-full d-theme-dark-bg col-span-6 login-form-container">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4" style="font-size: 26px">로그인</h4>
                  <p style="font-size: 17px">아이디와 비밀번호를 입력해주세요.</p>
                </div>

                <div class="pt-1">
                  <ml-input name="email" icon-no-border icon="icon icon-user" icon-pack="feather" label-placeholder="아이디 입력" v-model="emailInput" class="w-full" :removeChars="['@']" />

                  <ml-input type="password" name="password" icon-no-border icon="icon icon-lock" icon-pack="feather" label-placeholder="비밀번호 입력" v-model="passwordInput" class="w-full mt-6" @keyup.enter="login" />

                  <div class="flex flex-wrap justify-between my-6">
                    <vs-checkbox v-model="checkbox_remember_me" class="mb-3">아이디 기억하기</vs-checkbox>
                    <router-link to="/forgot-password">비밀번호를 잊으셨나요?</router-link>
                  </div>

                  <vue-recaptcha v-if="recaptcha" class="mb-8" ref="recaptcha" @expired="onExpired" @render="cargarCaptchar = true" @error="recaptchar = false" @verify="onVerify" sitekey="6LdUVN0aAAAAAH3ks4Ji-iuhmZ00-Af6W9xhxZGU" />
                  <div class="flex justify-between items-center mb-4">
                    <vs-button type="border" color="secondary" to="/register">회원가입</vs-button>
                    <vs-button v-if="isLoginInProgress" color="secondary" disabled>잠시만 기다려주세요</vs-button>
                    <vs-button v-else color="secondary" @click="login">로그인</vs-button>
                  </div>
                  <div class="login-bottom-buttons">
                    <vs-button type="border" color="primary" @click="openGuideVideo" class="guide-video-btn">
                      <i class="feather icon-video mr-3"></i>
                      <span>회원가입 안내영상</span>
                    </vs-button>
                    <button class="privacy-link-btn" @click="showPrivacyPolicy = true">
                      <i class="feather icon-shield"></i>
                      <span>개인정보처리방침</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>

      <div class="helpdesk-section-standalone">
        <div class="helpdesk-header" @click="toggleHelpdesk">
          <i class="feather icon-headphones helpdesk-icon"></i>
          <h3 class="helpdesk-title">헬프데스크</h3>
          <i :class="['feather', isHelpdeskOpen ? 'icon-chevron-up' : 'icon-chevron-down', 'helpdesk-toggle-icon']"></i>
        </div>
        <div v-show="isHelpdeskOpen" class="helpdesk-content">
          <div v-if="isMobile" class="helpdesk-mobile-grid">
            <div class="helpdesk-card" v-for="item in helpdeskInfo" :key="item.location">
              <div class="location-badge">{{ item.location }}</div>
              <div class="contact-info">
                <div class="contact-name">{{ item.name }}</div>
                <div class="contact-phone">
                  <i class="feather icon-phone"></i>
                  <span>{{ item.phone }}</span>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="helpdesk-desktop-grid">
            <div class="helpdesk-card" v-for="item in helpdeskInfo" :key="item.location">
              <div class="location-badge">{{ item.location }}</div>
              <div class="contact-info">
                <div class="contact-name">{{ item.name }}</div>
                <div class="contact-phone">
                  <i class="feather icon-phone"></i>
                  <span>{{ item.phone }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <popup-account-alert v-model="popupAccountAlert.show" :title="popupAccountAlert.title" :message="popupAccountAlert.message" :is-reason="popupAccountAlert.isReason" :reason="popupAccountAlert.reason" />
    <popup-privacy-policy v-model="showPrivacyPolicy" />
  </div>
</template>

<script>
import config from "/public/config";
import VueCookie from "vue-cookie";
import constant from "@/constant/constant";
import VueRecaptcha from "vue-recaptcha";
import PopupAccountAlert from "@/views/pages/login/PopupAccountAlert.vue";
import PopupPrivacyPolicy from "@/views/pages/login/PopupPrivacyPolicy.vue";

export default {
  components: {
    PopupPrivacyPolicy,
    PopupAccountAlert,
    VueRecaptcha,
  },
  watch: {
    checkbox_remember_me(checkbox_remember_me) {
      this.checkbox_remember_me = checkbox_remember_me;
      VueCookie.set("login_remember_me", checkbox_remember_me, 30);

      if (!this.checkbox_remember_me) {
        VueCookie.set("login_remember_email", "");
      }
    },
  },
  data() {
    return {
      loginLeftImage: "",
      loginTopImage: require("@/assets/images/pages/DigitalSHMSystem_Login_top.svg"),
      hostname: config.HOST_NAME,
      emailInput: "",
      passwordInput: "",
      checkbox_remember_me: false,
      recaptcha: false,
      recaptchaValue: "",
      isLoginInProgress: false, // 로그인 진행중인지 여부
      windowWidth: window.innerWidth,
      isHelpdeskOpen: false, // 헬프데스크 섹션 토글 상태 (기본적으로 접혀있음)

      helpdeskInfo: [
        { location: "인천", name: "방진솔 과장", phone: "032-830-6250" },
        { location: "포항", name: "강경훈 대리", phone: "054-721-3240" },
        { location: "당진", name: "최재영 부장", phone: "041-351-4622" },
        { location: "연구소", name: "오승훈 대리", phone: "054-271-2715" },
        { location: "본사", name: "송현수 대리", phone: "02-317-1187" },
      ],

      popupAccountAlert: {
        show: false,
        title: "승인 대기중인 계정입니다.",
        message: "관리자에게 문의해주세요.",
        isReason: false,
        reason: "",
      },
      showPrivacyPolicy: false,
    };
  },
  computed: {
    emailRules() {
      return this.checkEmailRule(this.emailInput);
    },
    isMobile() {
      return this.windowWidth <= 768;
    },
  },
  created() {
    this.loadLoginLeftImage().then();
    this.loadLoginTopImage().then();

    this.checkbox_remember_me = VueCookie.get("login_remember_me") === "true";
    if (this.checkbox_remember_me) {
      this.emailInput = VueCookie.get("login_remember_email") ? VueCookie.get("login_remember_email") : "";
    }

    window.addEventListener("resize", () => {
      this.windowWidth = window.innerWidth;
    });
  },
  destroyed() {
    window.removeEventListener("resize", () => {
      this.windowWidth = window.innerWidth;
    });
  },
  methods: {
    onVerify(r) {
      this.recaptchaValue = r;
      this.recaptcha = true;
    },
    onExpired() {
      this.$refs.recaptcha.reset();
    },

    /**
     * 로그인 화면에서 왼편에 표시되는 이미지를 불러온다
     * 24시간 동안 캐싱 유지
     */
    async loadLoginLeftImage() {
      const cacheKey = `${this.hostname}_login_left_image`;
      const cacheExpiryKey = `${this.hostname}_login_left_image_expiry`;
      const currentTime = new Date().getTime();

      try {
        // 캐시된 데이터 확인
        const cachedImage = localStorage.getItem(cacheKey);
        const cachedExpiry = localStorage.getItem(cacheExpiryKey);

        // 캐시가 유효한지 확인 (데이터 존재 + 만료시간 존재 + 만료시간이 현재보다 미래)
        if (cachedImage && cachedExpiry) {
          const expiryTime = Number(cachedExpiry);

          if (currentTime < expiryTime) {
            // 유효한 캐시 데이터 사용
            this.loginLeftImage = cachedImage;
            return;
          }
        }

        // 캐시가 없거나 만료된 경우 서버에서 데이터 가져오기
        const config = await this.$store.dispatch("keyValue/LOAD_CONFIG", {
          key: "login_left_image",
        });

        // 데이터가 성공적으로 로드되었다면 캐시 갱신
        if (config && config.path) {
          // 24시간 후 만료시간 설정 (24 * 60 * 60 * 1000 = 86400000 밀리초)
          const expiryTime = currentTime + 86400000;

          // 캐시와 만료시간 저장
          localStorage.setItem(cacheKey, config.path);
          localStorage.setItem(cacheExpiryKey, String(expiryTime));

          this.loginLeftImage = config.path;
        }
      } catch (error) {
        console.error("[CACHE ERROR] Login Left Image:", error);

        // 오류 발생 시 서버에서 데이터 가져오기 시도
        try {
          const config = await this.$store.dispatch("keyValue/LOAD_CONFIG", {
            key: "login_left_image",
          });

          if (config && config.path) {
            this.loginLeftImage = config.path;
          }
        } catch (fallbackError) {
          console.error("[CACHE FALLBACK ERROR] Login Left Image:", fallbackError);
        }
      }
    },

    /**
     * 로그인 화면에서 상단에 표시되는 이미지를 불러온다
     * 24시간 동안 캐싱 유지
     */
    async loadLoginTopImage() {
      const cacheKey = `${this.hostname}_login_top_image`;
      const cacheExpiryKey = `${this.hostname}_login_top_image_expiry`;
      const currentTime = new Date().getTime();

      try {
        // 캐시된 데이터 확인
        const cachedImage = localStorage.getItem(cacheKey);
        const cachedExpiry = localStorage.getItem(cacheExpiryKey);

        // 캐시가 유효한지 확인 (데이터 존재 + 만료시간 존재 + 만료시간이 현재보다 미래)
        if (cachedImage && cachedExpiry) {
          const expiryTime = Number(cachedExpiry);

          if (currentTime < expiryTime) {
            // 유효한 캐시 데이터 사용
            this.loginTopImage = cachedImage;
            return;
          }
        }

        // 캐시가 없거나 만료된 경우 서버에서 데이터 가져오기
        const config = await this.$store.dispatch("keyValue/LOAD_CONFIG", {
          key: "login_top_image",
        });

        // 데이터가 성공적으로 로드되었다면 캐시 갱신
        if (config && config.path) {
          // 24시간 후 만료시간 설정 (24 * 60 * 60 * 1000 = 86400000 밀리초)
          const expiryTime = currentTime + 86400000;

          // 캐시와 만료시간 저장
          localStorage.setItem(cacheKey, config.path);
          localStorage.setItem(cacheExpiryKey, String(expiryTime));

          this.loginTopImage = config.path;
        }
      } catch (error) {
        console.error("[CACHE ERROR] Login Top Image:", error);

        // 오류 발생 시 서버에서 데이터 가져오기 시도
        try {
          const config = await this.$store.dispatch("keyValue/LOAD_CONFIG", {
            key: "login_top_image",
          });

          if (config && config.path) {
            this.loginTopImage = config.path;
          }
        } catch (fallbackError) {
          console.error("[CACHE FALLBACK ERROR] Login Top Image:", fallbackError);
        }
      }
    },

    handleChangeRememberMe(/*data*/) {},
    checkEmailRule(v) {
      if (v === "") {
        return true;
      }

      const regExp = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;
      return !regExp.test(v);
    },

    async login() {
      if (this.isLoginInProgress) return;

      const email = this.emailInput;
      const pw = this.passwordInput;
      const rcv = this.recaptchaValue;

      if (!email) {
        alert("아이디를 입력해주세요");
        return;
      }
      if (email.length < 3) {
        alert("아이디는 3글자 이상이어야 합니다.");
        return;
      }

      if (!pw) {
        alert("비밀번호를 입력해주세요");
        return;
      }

      // 비밀번호가 8자 이상, 소문자, 대문자, 숫자가 포함되어있는지 검증
      // if (!/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]).{8,255}$/.test(pw)) {
      //   alert("비밀번호는 8자 이상, 소문자, 대문자, 숫자가 포함되어야 합니다.");
      //   return;
      // }

      this.isLoginInProgress = true;

      this.$store
        .dispatch("LOGIN", { email, pw, rcv })
        .then(async () => {
          if (VueCookie.get("login_remember_me") === "true") {
            VueCookie.set("login_remember_email", this.emailInput, 30);
          }

          this.$cookies.set("checkLogin", "1", "12h");
          localStorage.clear();
          await this.loadLoginLeftImage().then();
          await this.loadLoginTopImage().then();
          localStorage.setItem("login_username", email);

          // 사용자의 프로젝트 참여 현황을 조회하기 위해서, 사용자 정보를 조회한다
          await this.$store.dispatch("member/LOAD_MEMBER_DETAIL", { project_id: -1 /* 강제로 서버에서 불러오도록 한다 */ });
          const memberInfo = this.$store.state.member.memberInfo;

          const toFullPath = VueCookie.get("LOGIN_TO_FULLPATH");
          if (toFullPath) {
            this.$router.replace(toFullPath).then((/*value*/) => {
              VueCookie.delete("LOGIN_TO_FULLPATH"); // 로그인 후 이동할 페이지 삭제
              this.$router.go(0);
            });
          } else {
            // 참여 프로젝트의 개수가 1개일 경우, 해당 프로젝트 페이지로 바로 이동시킨다
            const projects = memberInfo.projects || [];
            if (memberInfo.projects.length === 1) {
              this.$router.replace(`/project/${projects[0].id}/home`).then((/*value*/) => {
                this.$router.go(0);
              });
            } else {
              this.$router.replace("/home").then((/*value*/) => {
                this.$router.go(0);
              });
            }
          }
        })
        .catch((err) => {
          if (this.recaptcha) {
            this.$refs.recaptcha.reset();
          }

          switch (constant.getErrorCode(err)) {
            case constant.ERROR_LOGIN_ID_NULL:
              alert("아이디를 입력해주세요");
              break;
            case constant.ERROR_LOGIN_PASSWORD_NULL:
              alert("비밀번호를 입력해주세요");
              break;
            case constant.ERROR_LOGIN_INVALID_CREDENTIALS:
              alert("아이디 또는 패스워드가 틀립니다");
              break;
            case constant.ERROR_LOGIN_INVALID_RECAPTCHA:
              this.recaptcha = true;
              break;

            case constant.ERROR_LOGIN_PENDING_APPROVAL:
              this.popupAccountAlert.show = true;
              this.popupAccountAlert.title = "회원가입 승인 대기 중인 회원입니다.";
              this.popupAccountAlert.message = "회원가입 승인이 완료되면 서비스를 이용하실 수 있습니다.\n대기가 지속되면 관리담당자에게 문의해보세요.";
              this.popupAccountAlert.isReason = false;
              break;
            case constant.ERROR_LOGIN_NOT_APPROVAL:
              this.popupAccountAlert.show = true;
              this.popupAccountAlert.title = "회원가입이 거절된 회원입니다.";
              this.popupAccountAlert.message = "관리담당자에게 문의해보세요.";
              this.popupAccountAlert.isReason = true;
              this.popupAccountAlert.reason = err.response.data.message ? err.response.data.message : "";
              break;

            case -1:
              switch (err.response.data) {
                case "The login must be between 2 and 255 characters.":
                  alert("아이디는 2자 이상 255자 이하로 입력해주세요.");
                  break;
                case "The password must be between 4 and 255 characters.":
                  alert("비밀번호는 4자 이상 255자 이하로 입력해주세요.");
                  break;
                default:
                  alert(err.response.data);
                  break;
              }
              break;
          }
          this.isLoginInProgress = false;
        });
    },

    /**
     * 회원가입 안내영상을 새 탭에서 엽니다
     */
    openGuideVideo() {
      window.open("https://youtu.be/laalkONWQXU", "_blank");
    },

    /**
     * 헬프데스크 섹션 토글
     */
    toggleHelpdesk() {
      this.isHelpdeskOpen = !this.isHelpdeskOpen;
    },
  },
};
</script>

<style lang="scss" scoped>
#page-login {
  min-height: 100vh;
  background-attachment: fixed;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  position: relative;

  // PC와 모바일 모두에서 배경 고정을 위한 가상 요소
  &::before {
    content: "";
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: inherit;
    background-attachment: scroll;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    z-index: -1;
  }

  // 모바일에서 background-attachment: fixed가 제대로 작동하지 않는 경우 대응
  @media (max-width: 768px) {
    background-attachment: scroll;
    min-height: 100vh;
    background-size: cover;
  }

  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }

    .bg-twitter {
      background-color: #00aaff;
    }

    .bg-google {
      background-color: #4285f4;
    }

    .bg-github {
      background-color: #333;
    }
  }
}

// 로그인 카드 컨테이너 높이 조정
.login-image-container {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .login-left-image {
    width: 100%;
    max-width: 550px;
    height: 100%;
    min-height: 430px;
    object-fit: cover;
    border-radius: 0;
  }
}

.login-form-container {
  padding: 40px 0;
  min-height: 430px;
  display: flex;
  align-items: center;

  .login-tabs-container {
    width: 100%;
  }
}

// 로그인 폼 하단 버튼 컨테이너
.login-bottom-buttons {
  // 데스크톱: 가로 배치
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;

  // 모바일: 세로 배치
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;

    .privacy-link-btn {
      width: 100%;
      justify-content: center;
      padding: 12px 16px;
      min-height: 44px; // 터치 친화적 높이
    }

    .guide-video-btn {
      width: 100%;
      min-height: 44px; // 터치 친화적 높이
    }
  }

  .guide-video-btn {
    display: flex;
    align-items: center;
    gap: 8px;

    i {
      font-size: 16px;
    }
  }
}

// 로그인 폼 내부의 개인정보처리방침 버튼
.privacy-link-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  color: #6b7280;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 8px 12px;
  border-radius: 6px;

  &:hover {
    color: #6366f1;
    background: #f8fafc;
  }

  i {
    font-size: 14px;
  }
}

// 독립적인 헬프데스크 섹션
.helpdesk-section-standalone {
  margin-top: 32px;

  .helpdesk-header {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    margin-bottom: 20px;
    cursor: pointer; // 클릭 가능하도록 커서 변경
    padding: 12px 20px;
    border-radius: 12px;
    transition: all 0.3s ease;
    user-select: none;

    &:hover {
      background: #f8fafc;
      transform: translateY(-1px);
    }

    .helpdesk-icon {
      color: #6366f1;
      font-size: 22px;
    }

    .helpdesk-title {
      font-size: 20px;
      font-weight: 600;
      color: #1f2937;
      margin: 0;
    }

    .helpdesk-toggle-icon {
      color: #6366f1;
      font-size: 20px;
      transition: transform 0.3s ease;
      margin-left: auto;
    }
  }

  .helpdesk-content {
    animation: slideDown 0.3s ease-out;
    transform-origin: top;

    .helpdesk-mobile-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 16px;
      max-width: 400px;
      margin: 0 auto;
    }

    .helpdesk-desktop-grid {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      gap: 18px;
      max-width: 900px;
      margin: 0 auto;
    }

    .helpdesk-card {
      background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);
      border: 1px solid #e5e7eb;
      border-radius: 12px;
      padding: 18px 12px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
      transition: all 0.3s ease;
      text-align: center;
      min-width: 160px;

      &:hover {
        transform: translateY(-3px);
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);
        border-color: #6366f1;
      }

      .location-badge {
        background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
        color: white;
        font-size: 12px;
        font-weight: 600;
        padding: 6px 12px;
        border-radius: 8px;
        display: inline-block;
        margin-bottom: 12px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        box-shadow: 0 2px 4px rgba(99, 102, 241, 0.3);
      }

      .contact-info {
        .contact-name {
          font-size: 14px;
          font-weight: 500;
          color: #374151;
          margin-bottom: 8px;
        }

        .contact-phone {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 4px;
          font-size: 12px;
          color: #6b7280;
          white-space: nowrap;

          i {
            font-size: 10px;
            color: #6366f1;
            flex-shrink: 0;
          }

          span {
            font-family: "Courier New", monospace;
            font-weight: 500;
            font-size: 11px;
          }
        }
      }
    }
  }
}

.input-font::v-deep {
  span {
    font-size: 16px !important;
    height: 100%;
  }
  input {
    font-size: 16px !important;
  }
}

@media print, screen and (max-width: theme("screens.xl")) {
  .vx-col {
    width: 95%;
  }

  .lt-postion-logo {
    display: none;
  }
}

// 모바일 최적화
@media (max-width: 768px) {
  .helpdesk-section-standalone {
    margin-top: 40px;
    margin-bottom: 40px; // 하단 여백 추가

    .helpdesk-header {
      margin-bottom: 24px;
      padding: 10px 16px;

      .helpdesk-icon {
        font-size: 20px;
      }

      .helpdesk-title {
        font-size: 18px;
      }

      .helpdesk-toggle-icon {
        font-size: 18px;
      }
    }

    .helpdesk-content {
      .helpdesk-card {
        padding: 16px 12px;
        min-width: unset;

        .location-badge {
          font-size: 10px;
          padding: 6px 10px;
          margin-bottom: 10px;
        }

        .contact-info {
          .contact-name {
            font-size: 13px;
            margin-bottom: 6px;
          }

          .contact-phone {
            font-size: 11px;
            gap: 3px;

            i {
              font-size: 9px;
            }

            span {
              font-size: 11px;
            }
          }
        }
      }
    }
  }

  .privacy-link-btn {
    font-size: 15px;
    padding: 12px 16px;
  }
}

// 대형 화면 최적화
@media (min-width: 1200px) {
  .helpdesk-section-standalone {
    .helpdesk-content {
      .helpdesk-desktop-grid {
        gap: 24px;
        max-width: 1000px;
      }

      .helpdesk-card {
        padding: 20px 16px;
        min-width: 180px;

        .contact-phone {
          font-size: 12px;

          span {
            font-size: 12px;
          }
        }
      }
    }
  }
}

// 헬프데스크 토글 애니메이션
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
